
export class StateListItem {

	label : string;
	value : string;

}

export class StateList {


	private static states : StateListItem[] = [
		{ label : "", value : ""}, 
		
		{ label : "Alabama", value : "AL"}, 
		{ label : "Alaska", value : "AK"}, 
		{ label : "American Samoa", value : "AS"}, 
		{ label : "Arizona", value : "AZ"}, 
		{ label : "Arkansas", value : "AR"}, 
		{ label : "California", value : "CA"}, 
		{ label : "Colorado", value : "CO"}, 
		{ label : "Connecticut", value : "CT"}, 
		{ label : "Delaware", value : "DE"}, 
		{ label : "District Of Columbia", value : "DC"}, 
		{ label : "Federated States Of Micronesia", value : "FM"}, 
		{ label : "Florida", value : "FL"}, 
		{ label : "Georgia", value : "GA"}, 
		{ label : "Guam", value : "GU"}, 
		{ label : "Hawaii", value : "HI"}, 
		{ label : "Idaho", value : "ID"}, 
		{ label : "Illinois", value : "IL"}, 
		{ label : "Indiana", value : "IN"}, 
		{ label : "Iowa", value : "IA"}, 
		{ label : "Kansas", value : "KS"}, 
		{ label : "Kentucky", value : "KY"}, 
		{ label : "Louisiana", value : "LA"}, 
		{ label : "Maine", value : "ME"}, 
		{ label : "Marshall Islands", value : "MH"}, 
		{ label : "Maryland", value : "MD"}, 
		{ label : "Massachusetts", value : "MA"}, 
		{ label : "Michigan", value : "MI"}, 
		{ label : "Minnesota", value : "MN"}, 
		{ label : "Mississippi", value : "MS"}, 
		{ label : "Missouri", value : "MO"}, 
		{ label : "Montana", value : "MT"}, 
		{ label : "Nebraska", value : "NE"}, 
		{ label : "Nevada", value : "NV"}, 
		{ label : "New Hampshire", value : "NH"}, 
		{ label : "New Jersey", value : "NJ"}, 
		{ label : "New Mexico", value : "NM"}, 
		{ label : "New York", value : "NY"}, 
		{ label : "North Carolina", value : "NC"}, 
		{ label : "North Dakota", value : "ND"}, 
		{ label : "Northern Mariana Islands", value : "MP"}, 
		{ label : "Ohio", value : "OH"}, 
		{ label : "Oklahoma", value : "OK"}, 
		{ label : "Oregon", value : "OR"}, 
		{ label : "Palau", value : "PW"}, 
		{ label : "Pennsylvania", value : "PA"}, 
		{ label : "Puerto Rico", value : "PR"}, 
		{ label : "Rhode Island", value : "RI"}, 
		{ label : "South Carolina", value : "SC"}, 
		{ label : "South Dakota", value : "SD"}, 
		{ label : "Tennessee", value : "TN"}, 
		{ label : "Texas", value : "TX"}, 
		{ label : "Utah", value : "UT"}, 
		{ label : "Vermont", value : "VT"}, 
		{ label : "Virgin Islands", value : "VI"}, 
		{ label : "Virginia", value : "VA"}, 
		{ label : "Washington", value : "WA"}, 
		{ label : "West Virginia", value : "WV"}, 
		{ label : "Wisconsin", value : "WI"}, 
		{ label : "Wyoming", value : "WY"}
	];


	public static States() : StateListItem[] {
		return this.states;
	} 


	public static ValidCountry( country : string ) : string {

		

		let theList = StateList.States();

		//console.log("The List:", theList);

		for( let c = 0; c < theList.length; c++ ) {
			if( theList[c].value.toLowerCase() == country.toLowerCase() || theList[c].label.toLowerCase() == country.toLowerCase() ) {
				
				return theList[c].value;

			}
		}

		console.log("No State Match for '" + country + "'");
		return "";

	}



}

export const DualStateZipcodeList = {
	'02861': ['MA', 'RI'],
	'42223': ['KY', 'TN'],
	'59221': ['MT', 'ND'],
	'63673': ['IL', 'MO'],
	'71749': ['AR', 'LA'],
	'73949': ['OK', 'TX'],
	'81137': ['CO', 'NM'],
	'84536': ['AZ', 'UT'],
	'86044': ['AZ', 'UT'],
	'86515': ['AZ', 'NM'],
	'88063': ['NM', 'TX'],
	'89439': ['CA', 'NV'],
	'97635': ['CA', 'OR'],
}